// import { useGlobalContext } from "context/GlobalContext";
// import { useEffect, useState } from "react";

// const useProductInCatalogCheck = (product, isEditCatagory, updateCatagoryData) => {
//   const [btnTitle, setBtnTitle] = useState(isEditCatagory ? "Select" : "Add");
//   const [presentInCatalog, setPresentInCatalog] = useState(false);

//   const { btnChange, setBtnChange } = useGlobalContext();

//   useEffect(() => {
//     const updateCatalogProductsData = JSON.parse(sessionStorage.getItem("updateProductsData")) || [];
//     const recentlyRemoved = JSON.parse(sessionStorage.getItem("RecentlyRemoved"));

//     if (updateCatalogProductsData.length > 0) {
//       const isAlreadyAdded = updateCatalogProductsData.find((curProduct) => {
//         const productId = curProduct.styleNumber || curProduct.styleNumber;
//         return productId == product.styleNumber;
//       });

//       if (isAlreadyAdded) {
//         setBtnTitle("Added");
//         setPresentInCatalog(true);
//       }
//     }

//     //check the cart data its presents or not
//     const data = JSON.parse(sessionStorage.getItem(isEditCatagory ? updateCatagoryData : "CartData")) || [];
//     if (data.length >= 0) {
//       const isAlreadyAdded = data.find((curProduct) => {
//         const productStyleNumber = curProduct.styleNumber;
//         return productStyleNumber === product.styleNumber;
//       });

//       const productStyleNumber = recentlyRemoved?.styleNumber;
//       const isNotInCart = productStyleNumber === product.styleNumber;

//       if (isAlreadyAdded) {
//         setBtnTitle(isEditCatagory ? "Selected" : "Added");
//       }
//       if (isNotInCart) {
//         setBtnTitle("Add");
//       }
//     }
//     setBtnChange(false);
//   }, [product.id || product._id, btnChange]);

//   return { setBtnTitle, btnTitle, presentInCatalog };
// };

// export default useProductInCatalogCheck;

// import { useGlobalContext } from "context/GlobalContext";
// import { useEffect, useState } from "react";

// const useStockInCatalog = (product) => {
//   const [btnTitle, setBtnTitle] = useState("Add");
//   const [presentInCatalog, setPresentInCatalog] = useState(false);
//   const { isInCart } = useGlobalContext();

//   useEffect(() => {
//     const updateCatalogProductsData = JSON.parse(sessionStorage.getItem("updateProductsData")) || [];

//     const recentlyRemoved = JSON.parse(sessionStorage.getItem("RecentlyRemoved"));

//     if (updateCatalogProductsData.length > 0) {
//       const isAlreadyAdded = updateCatalogProductsData.find((curProduct) => {
//         const productId = curProduct.styleNumber || curProduct.styleNumber;
//         return productId == product.styleNumber;
//       });

//       if (isAlreadyAdded) {
//         setBtnTitle("Added");
//         setPresentInCatalog(true);
//       }
//     }

//     const isAlreadyAdded = isInCart(product.styleNumber);
//     if (isAlreadyAdded) {
//       setBtnTitle("Added");
//     }

//     const productStyleNumber = recentlyRemoved?.styleNumber;
//     const isNotInCart = productStyleNumber === product.styleNumber;

//     if (isNotInCart) {
//       setBtnTitle("Add");
//     }
//   }, [product.styleNumber, isInCart]);

//   return { setBtnTitle, btnTitle, presentInCatalog };
// };

// export default useStockInCatalog;

// import { useGlobalContext } from "context/GlobalContext";
// import { useEffect, useState } from "react";

// const useStockInCatalog = (product, isEditCatagory, updateCatagoryData) => {
//   const [btnTitle, setBtnTitle] = useState(isEditCatagory ? "Select" : "Add");
//   const [presentInCatalog, setPresentInCatalog] = useState(false);
//   const { isInCart, updateCatalogProductsData, recentlyRemoved, setUpdateCatalogProductsData } = useGlobalContext();

//   useEffect(() => {
//     sessionStorage.removeItem("RecentlyRemoved");
//     const updatProductData = JSON.parse(sessionStorage.getItem("updateProductsData")) || [];
//     setUpdateCatalogProductsData(updatProductData);
//     const isInUpdatedCatalog = updateCatalogProductsData.find((curProduct) => {
//       return curProduct.styleNumber === product.styleNumber;
//     });

//     if (isInUpdatedCatalog) {
//       setBtnTitle("Added");
//       setPresentInCatalog(true);
//     } else if (isInCart(product.styleNumber)) {
//       setBtnTitle("Added");
//       setPresentInCatalog(false);
//     } else if (recentlyRemoved?.styleNumber === product.styleNumber) {
//       setBtnTitle("Add");
//     }

//     if (isEditCatagory) {
//       const data = JSON.parse(sessionStorage.getItem(updateCatagoryData)) || [];
//       if (data.length > 0) {
//         const isAlreadyAdded = data.find((curProduct) => {
//           // const productId = product._id || curProduct.id;
//           const productId = curProduct.styleNumber || curProduct.styleNumber;
//           return productId === product.styleNumber;
//         });

//         if (isAlreadyAdded) {
//           setBtnTitle("Selected");
//         }
//       }
//     }
//   }, [product.styleNumber, isInCart, updateCatalogProductsData, recentlyRemoved]);

//   return { setBtnTitle, btnTitle, presentInCatalog };
// };

import { useEffect, useState } from "react";
import { useGlobalContext } from "../context/GlobalContext";

const useStockInCatalog = (product, isEditCategory, updateCategoryDataKey) => {
  const [btnTitle, setBtnTitle] = useState(isEditCategory ? "Select" : "Add");
  const [presentInCatalog, setPresentInCatalog] = useState(false);
  const { isInCart, updateCatalogProductsData, recentlyRemoved, setUpdateCatalogProductsData, isEditCatagorySelectValue, cartData } = useGlobalContext();

  useEffect(() => {
    const styleNumber = product.styleNumber;

    // Reset session values and sync catalog data
    sessionStorage.removeItem("RecentlyRemoved");
    const storedUpdateData = JSON.parse(sessionStorage.getItem("updateProductsData")) || [];
    // setUpdateCatalogProductsData(storedUpdateData);

    const isInUpdatedCatalog = storedUpdateData.some((item) => item.styleNumber === styleNumber);

    const isInCartAlready = isInCart(styleNumber);
    const wasRecentlyRemoved = recentlyRemoved?.styleNumber === styleNumber;

    // Determine base button title
    if (isInUpdatedCatalog || isInCartAlready) {
      setBtnTitle("Added");
      setPresentInCatalog(isInUpdatedCatalog);
    } else if (wasRecentlyRemoved) {
      setBtnTitle("Add");
    }

    // Handle edit-category-specific case
    if (isEditCategory && updateCategoryDataKey) {
      const editCategoryData = JSON.parse(sessionStorage.getItem(updateCategoryDataKey)) || [];
      const isSelectedInCategory = editCategoryData.some((item) => item.styleNumber === styleNumber);

      if (isSelectedInCategory) {
        setBtnTitle("Selected");
      } else {
        setBtnTitle("Select");
      }
    }
  }, [cartData, product]);

  return { btnTitle, setBtnTitle, presentInCatalog, isEditCatagorySelectValue };
};

export default useStockInCatalog;

// export default useStockInCatalog;
